import OrderTransportingOrderAvailableDriversRequest from "../../../../api/raily/order/transporting-order/available-drivers/order-transporting-order-available-drivers.request";
import OrderTransportingOrderAvailableDriversParams from "./order-transporting-order-available-drivers-params";

const create = (
  params: OrderTransportingOrderAvailableDriversParams,
): OrderTransportingOrderAvailableDriversRequest => {
  return {
    fulltextSearchCriteria: params.fulltextSearchCriteria,
    transportingOrderUuid: params.transportingOrderUuid,
    limit: params.limit,
  };
};

const orderTransportingOrderAvailableDriversParamsFactory = {
  create,
};

export default orderTransportingOrderAvailableDriversParamsFactory;
